"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[560],{

/***/ 560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GarageProfilePickupService": function() { return /* binding */ GarageProfilePickupService; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);





var GarageProfilePickupService = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(GarageProfilePickupService, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(GarageProfilePickupService);
    function GarageProfilePickupService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, GarageProfilePickupService);
        return _super.apply(this, arguments);
    }
    var _proto = GarageProfilePickupService.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "col-span-full mb-6 md:mb-8",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "text-base leading-6 md:text-xl md:leading-7 font-semibold font-serif text-gray-900 mb-4",
                    children: "Hol- & Bringservice der Werkstatt"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-base leading-6 font-normal text-gray-900",
                    children: "Die Werkstatt holt dein Auto bei dir ab. Wenn sie fertig mit deinem Auto ist, bringt sie es dir wieder zur\xfcck."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-base leading-6 font-normal text-gray-900 italic",
                    children: "Kann unter Komfortservice hinzugef\xfcg werden. Bitte w\xe4hle daf\xfcr zuerst einen Service aus."
                })
            ]
        });
    };
    return GarageProfilePickupService;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);


/***/ })

}]);